import { combineReducers } from "redux";
import {
  userReducer,
  loginReducer,
  sessionidentifierReducer,
  getcategorydataReducer,
  storeOrdersReducer,
  productReducer,
  customerReducer,
  orderlinesReducer,
  createorderReducer,
  orderReceiptReducer,
  productsReducer,
  draftOrderReducer,
  returnProductReducer,
  refundReducer,
  sessionReducer,
  removeFavReducer,
  paymentReducer,
  permissionReducer,
  groupModalOpen,
  paymentModalOpen
} from "./index";

const rootReducer = combineReducers({
  user: userReducer,
  login: loginReducer,
  sessionIdentify: sessionidentifierReducer,
  productData: getcategorydataReducer,
  orders: storeOrdersReducer,
  updatefavproduct: productReducer,
  getcustomer: customerReducer,
  orderlinesReducer: orderlinesReducer,
  createorderReducer: createorderReducer,
  orderReceiptReducer: orderReceiptReducer,
  products: productsReducer,
  draftOrders: draftOrderReducer,
  returnProductReducer: returnProductReducer,
  refundReducer: refundReducer,
  sessionReducer: sessionReducer,
  removeFavReducer: removeFavReducer,
  paymentReducer: paymentReducer,
  permissionReducer : permissionReducer,
  groupModalOpen : groupModalOpen,
  paymentModalOpen : paymentModalOpen,
});

export default rootReducer;
